export default __webpack_public_path__ + "static/media/mongoDB.4428e2ce.svg";